import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4547839c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-form__block mb-10px" }
const _hoisted_2 = {
  key: 0,
  class: "step-finish__title"
}
const _hoisted_3 = {
  key: 1,
  class: "order-info"
}
const _hoisted_4 = { class: "order-info__block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text _tit" }, "Данные покупателя", -1))
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = {
  key: 0,
  class: "text"
}
const _hoisted_9 = {
  key: 1,
  class: "inputwrapper"
}
const _hoisted_10 = { class: "order-info__block" }
const _hoisted_11 = {
  key: 0,
  class: "text _tit"
}
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 1,
  class: "text"
}
const _hoisted_15 = {
  key: 2,
  class: "inputwrapper"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 0,
  class: "text _tit"
}
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "order-info__title" }
const _hoisted_22 = { class: "srok text mb-10px" }
const _hoisted_23 = { class: "time" }
const _hoisted_24 = { class: "price" }

import { computed, watch, ref } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds, TypeLoyaliyMainName } from "@/types";
import { IloyalityShopData, TypeReceiver } from "@/types/typesOfState";
import { Store } from "vuex";
import getExpirationStringForAbonement from "@/functions/getExpirationStringForAbonement";
import getExpirationStringForCertificate from "@/functions/getExpirationStringForCertificate";
import nextElementFocus from "@/functions/nextElementFocus";


export default /*#__PURE__*/_defineComponent({
  __name: 'stepFinish',
  setup(__props, { expose: __expose }) {

const store = useStore();

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);
const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const loyalityTypes = computed(() => store.state.allLoyalityTypes);

const receiver = computed<TypeReceiver>(
  () => store.state.loyalityShopData.receiver
);

const emailRecipient = computed<TypeReceiver>(
  () => store.state.loyalityShopData.emailRecipient
);

const isPayCreated = computed(() => !!store.state.currentPaymentData.OrderId);

const currentBuyLoyality = computed(() => {
  const currentBuy = [
    ...loyalityTypes.value.certificates,
    ...loyalityTypes.value.abonements,
  ].find((i) => i.id === loyalityShopData.value.buyLoyalityType);

  const expiration =
    currentLoyalityKind.value === "certificate"
      ? getExpirationStringForCertificate(currentBuy)
      : getExpirationStringForAbonement(currentBuy);

  return {
    type: currentBuy,
    expiration: expiration,
  };
});

const titleStr = computed(() => {
  return currentBuyLoyality.value.type.title.replace(/\//g, '|');
})

const invalidClientEmail = ref<boolean>(false);
const invalidBuyerEmail = ref<boolean>(false);
let invalidEmailText = ref<
  "Укажите корректный Email" | "Этот Email уже указан выше"
>();
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateFinishForm(): boolean {
  const clientEmail = loyalityShopData.value.clientData.email || null;
  const buyerEmail = loyalityShopData.value.buyerData.email || null;
  if (receiver.value === "self") {
    return true;
  } else {
    if (emailRecipient.value === "self") {
      const validatorValue = !!(buyerEmail && emailRegex.test(buyerEmail));

      if (validatorValue && clientEmail === buyerEmail) {
        loyalityShopData.value.clientData.email = null
      }

      invalidBuyerEmail.value = !validatorValue;

      return validatorValue;
    } else {
      if (!clientEmail || !emailRegex.test(clientEmail)) {
        invalidEmailText.value = "Укажите корректный Email"
        invalidClientEmail.value = true;
        return false
      } else if (clientEmail === buyerEmail) {
        invalidEmailText.value = "Этот Email уже указан выше"
        invalidClientEmail.value = true;
        return false
      } else {
        invalidClientEmail.value = false;
        return true
      }
    }
  }
}

__expose({ validateFinishForm });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Оплата прошла успешно!"))
      : _createCommentVNode("", true),
    (receiver.value === 'other')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(loyalityShopData.value.buyerData.name), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(loyalityShopData.value.buyerData.phone), 1),
            (
            isPayCreated.value ||
            (loyalityShopData.value.emailRecipient !== 'self' && receiver.value === 'other')
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(loyalityShopData.value.buyerData.email), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (invalidBuyerEmail.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "errorblock close",
                        onClick: _cache[0] || (_cache[0] = 
              (event) => {
                _unref(nextElementFocus)(event);
                invalidBuyerEmail.value = false;
              }
            )
                      }, _toDisplayString(_unref(invalidEmailText)), 1))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input post _disabled-text-hide", {
              error: invalidBuyerEmail.value,
            }]),
                    type: "text",
                    placeholder: "Мой адрес эл. почты",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loyalityShopData.value.buyerData.email) = $event)),
                    ref: "emailInput"
                  }, null, 2), [
                    [_vModelText, loyalityShopData.value.buyerData.email]
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (receiver.value === 'other')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Данные будущего владельца "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, _toDisplayString(loyalityShopData.value.clientData.name), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(loyalityShopData.value.clientData.phone), 1),
            (isPayCreated.value || loyalityShopData.value.emailRecipient !== 'other')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(loyalityShopData.value.clientData.email), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (invalidClientEmail.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "errorblock close",
                        onClick: _cache[2] || (_cache[2] = 
              (event) => {
                _unref(nextElementFocus)(event);
                invalidClientEmail.value = false;
              }
            )
                      }, _toDisplayString(_unref(invalidEmailText)), 1))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input post _disabled-text-hide", {
              error: invalidClientEmail.value,
            }]),
                    type: "text",
                    placeholder: "Эл. почта будущего владельца",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loyalityShopData.value.clientData.email) = $event)),
                    ref: "emailInput"
                  }, null, 2), [
                    [_vModelText, loyalityShopData.value.clientData.email]
                  ])
                ]))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (receiver.value === 'other')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Будущий владелец "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, _toDisplayString(loyalityShopData.value.clientData.name), 1),
          _createElementVNode("div", _hoisted_19, _toDisplayString(loyalityShopData.value.clientData.phone), 1),
          _createElementVNode("div", _hoisted_20, _toDisplayString(loyalityShopData.value.clientData.email), 1)
        ])),
    _createElementVNode("div", _hoisted_21, _toDisplayString(currentLoyalityKind.value === "certificate"
          ? "приобретаемый сертификат:"
          : "приобретаемый абонемент:") + " " + _toDisplayString(titleStr.value), 1),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("span", _hoisted_23, _toDisplayString(currentBuyLoyality.value.expiration), 1),
      _createElementVNode("span", _hoisted_24, _toDisplayString((currentLoyalityKind.value === "certificate"
            ? currentBuyLoyality.value.type.balance
            : currentBuyLoyality.value.type.cost
          ).toLocaleString()) + " ₽", 1)
    ])
  ]))
}
}

})